import React from 'react';
import ReactDOM from 'react-dom';
//import registerServiceWorker from './scripts/registerServiceWorker';
import axios from 'axios';
import jsonValidator from 'is-my-json-valid';

// loco blocks
import Header from './blocks/header/header.jsx';
import ProductGallery from './blocks/productgallery/productgallery.jsx';
import HotspotCarousel from './blocks/hotspotcarousel/hotspotcarousel.jsx';
import Cta from './blocks/cta/cta.jsx';
import NewsIndex from './blocks/newsindex/newsindex.jsx';
import ArticleIndex from './blocks/articleindex/articleindex.jsx';
import WhitePaperIndex from './blocks/whitepaperindex/whitepaperindex.jsx';
import EventIndex from './blocks/eventindex/eventindex.jsx';
import SocialBar from './blocks/socialbar/socialbar.jsx';
import Footer from './blocks/footer/footer.jsx';

// loco components
import TabbedContent from './components/tabbedcontent/tabbedcontent.jsx';
import Overlay from './components/overlay/overlay.jsx';

// loco styles
import './style/_mixins.scss';
import './style/global.scss';
import './style/icons.scss';
import './style/layout.scss';

// main app
const App = ({data}) => {

	// watch for contact form opening event
	window.addEventListener('Component.ContactForm.Open', (e) => {
		const form = <span className="component contactform">
						<h1>{data.form.title}</h1>
						<h2>{data.form.subtitle}</h2>
						<p>{data.form.copy}</p>
						<div className="form">
							<svg version="1.1" className="spinner" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="38" height="38" viewBox="0 0 38 38" preserveAspectRatio="xMinYMin meet" >
								<text x="14" y="21" fontFamily="Monaco" fontSize="2px" style={{letterSpacing:0.6}} fill="grey">
									LOADING
									<animate attributeName="opacity" values="0;1;0" dur="1.8s" repeatCount="indefinite"/>
								</text>
								<path fill="#ccc" d="M20,35c-8.271,0-15-6.729-15-15S11.729,5,20,5s15,6.729,15,15S28.271,35,20,35z M20,5.203 C11.841,5.203,5.203,11.841,5.203,20c0,8.159,6.638,14.797,14.797,14.797S34.797,28.159,34.797,20 C34.797,11.841,28.159,5.203,20,5.203z"/>
								<path fill="#ccc" d="M20,33.125c-7.237,0-13.125-5.888-13.125-13.125S12.763,6.875,20,6.875S33.125,12.763,33.125,20 S27.237,33.125,20,33.125z M20,7.078C12.875,7.078,7.078,12.875,7.078,20c0,7.125,5.797,12.922,12.922,12.922 S32.922,27.125,32.922,20C32.922,12.875,27.125,7.078,20,7.078z"/>
								<path fill="#cc0000" stroke="#cc0000" strokeWidth="0.6027" strokeMiterlimit="10" d="M5.203,20 c0-8.159,6.638-14.797,14.797-14.797V5C11.729,5,5,11.729,5,20s6.729,15,15,15v-0.203C11.841,34.797,5.203,28.159,5.203,20z">
									<animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" calcMode="spline" keySplines="0.4, 0, 0.2, 1" keyTimes="0;1" dur="2s" repeatCount="indefinite" />      
								</path>
								<path fill="#aaa" stroke="#aaa" strokeWidth="0.2027" strokeMiterlimit="10" d="M7.078,20 c0-7.125,5.797-12.922,12.922-12.922V6.875C12.763,6.875,6.875,12.763,6.875,20S12.763,33.125,20,33.125v-0.203 C12.875,32.922,7.078,27.125,7.078,20z">
									<animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1.8s" repeatCount="indefinite" />
								</path>
							</svg>

							<iframe src={data.form.url} frameBorder="0" title={data.form.title} style={{width: '100%', minHeight : '100vh'}}></iframe>
						</div>
					</span>

		window.dispatchEvent(new CustomEvent('Component.Overlay.Open', {detail: {content : form}}))
	}, false);

	// render main
	return 	<main>
				<Overlay/>
				<ProductGallery/>
				<Header data={data.header}/>
				<HotspotCarousel data={data.gallery}/>
				<Cta data={data.cta}/>
				
				<TabbedContent>
					<NewsIndex data={data.news} name="Recent Stories"/>
					<ArticleIndex data={data.articles} name="Case Studies"/>
					<WhitePaperIndex data={data.whitepapers} name="White papers"/>
					<EventIndex data={data.events} name="Events"/>
				</TabbedContent>

				<SocialBar/>
				<Footer/>
			</main>
}


(function () {
  if ( typeof window.CustomEvent === "function" ) return false; //If not IE

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

//console.log(window.location)


// fetch data
axios.get('./data.json')
	.then(response => {
		
		var validate = jsonValidator({ required: true, type: 'object' })

		if(!validate(response.data)){
			throw new Error("Invalid JSON file. Please check it at https://jsonformatter.curiousconcept.com/");
		}

		ReactDOM.render(<App data={response.data}/>, document.getElementById('root'));
	})
	.catch(error => {
		console.error(error);
	});


// enable scroll
window.addEventListener('Window.Scroll.Disabled', e => {
	document.body.setAttribute('data-scroll', false);
	if(e.detail && e.detail.callback && typeof e.detail.callback === 'function') e.detail.callback()
}, false);

// disable scroll
window.addEventListener('Window.Scroll.Enabled', e => {
	document.body.setAttribute('data-scroll', true);
	if(e.detail && e.detail.callback && typeof e.detail.callback === 'function') e.detail.callback()
}, false);


//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.jsx